import {
  RESET_PENDING_ORDER,
  SET_PENDING_ORDER,
  UPDATE_ADDRESS,
  UPDATE_PENDING_ORDER,
} from '../actions/types';
import { getEmptyPendingOrderPayload } from '../../constants';

const INITIAL_STATE = {};

export default (state: any = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PENDING_ORDER:
      return { ...state, ...action.payload };
    case SET_PENDING_ORDER:
      return { ...action.payload, isInit: true };
    case RESET_PENDING_ORDER:
      return getEmptyPendingOrderPayload();
    case UPDATE_ADDRESS:
      return {
        ...state,
        address: action.payload.address,
        addressIsLoaded: true,
      };
    default:
      return state;
  }
};
